import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IAffiliateTrackerCountryResponse, IChangeTrackerCountryPayload } from '../types';
import {
  AFFILIATE_CHANGE_TRACKER_COUNTRY_API_URL,
  AFFILIATE_CHANGE_TRACKER_COUNTRY_MUTATION,
  AFFILIATE_GET_TRACKER_COUNTRY_QUERY,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useChangeTrackerCountryMutation(): IContextMutationResult<void, Error, IChangeTrackerCountryPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangeTrackerCountryPayload>({
    mutationKey: [AFFILIATE_CHANGE_TRACKER_COUNTRY_MUTATION],
    mutationFn: ({ id, trackerId, ...payload }) => fetchPut<void>(
      AFFILIATE_CHANGE_TRACKER_COUNTRY_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.UPDATE_COUNTRY,
        urlParams: {
          id,
          trackerId,
        },
      },
    ),
    onSuccess({ queryClient, variables }) {
      queryClient.setQueriesData<IAffiliateTrackerCountryResponse>(
        { queryKey: [AFFILIATE_GET_TRACKER_COUNTRY_QUERY, variables.id, variables.trackerId] },
        (queryData) => {
          if (!queryData) {
            return queryData;
          }

          return {
            ...queryData,
            country_code: variables.country_code,
          };
        },
      );
      displayPresetToast('edited');
    },
  });
}
